import React from "react";
import { NotificationContainer, NotificationManager } from "react-notifications";

const FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLScNamc82zH0EVR6CgCcB0WRM-NSm90DeGW2_uGfDK3Oj66wpg/formResponse";

const ContactForm = () => {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [interest, setInterest] = React.useState(""); // 🔥 NEW
  const [message, setMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!name) return NotificationManager.error("Name is required");
    if (!email) return NotificationManager.error("Email is required");
    if (!phone) return NotificationManager.error("Phone number is required");
    if (!interest) return NotificationManager.error("Please select an option");

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("entry.1102309209", name);        // Name
      formData.append("emailAddress", email);          // Email
      formData.append("entry.774180726", phone);       // Phone
      formData.append("entry.1793295208", interest);   // 🔥 Interest (Dropdown)
      formData.append("entry.371784238", message);     // Message

      await fetch(FORM_URL, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      });


      NotificationManager.success("Message has been sent!");
      
      // 🔥 META / GTM LEAD EVENT
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "lead_form_submit",
        course_interest: interest,          // Japanese / German / French / Coding
        page_path: window.location.pathname,
        form_type: "contact_form"
      });

      // Reset form
      setName("");
      setEmail("");
      setPhone("");
      setInterest(""); // 🔥 reset
      setMessage("");

    } catch (error) {
      NotificationManager.error("Oops! Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact__card">
      <form onSubmit={handleSubmit} className="contact__card--form">
        <h5>Contact Us</h5>

        <div className="contact__card--form-control">
          <input
            className="form-control"
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="contact__card--form-control">
          <input
            className="form-control"
            type="email"
            placeholder="name@company.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="contact__card--form-control">
          <input
            className="form-control"
            type="text"
            minLength={10}
            maxLength={10}
            placeholder="Contact No."
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>

        {/* 🔥 DROPDOWN FIELD */}
        <div className="contact__card--form-control">
          <select
            className="form-control"
            value={interest}
            onChange={(e) => setInterest(e.target.value)}
            required
          >
            <option value="">-- What do you want to learn? --</option>
            <option value="I want to Learn Japanese">I want to Learn Japanese</option>
            <option value="I want to Learn German">I want to Learn German</option>
            <option value="I want to Learn French">I want to Learn French</option>
            <option value="I want to Learn Coding">I want to Learn Coding</option>
            <option value="I have other query">I have other query</option>
          </select>
        </div>

        <div className="contact__card--form-control">
          <textarea
            className="form-control"
            rows="3"
            placeholder="Let us know how we can help you"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? "Sending..." : "Contact Now"}
        </button>
      </form>

      <NotificationContainer />
    </div>
  );
};

export default ContactForm;
